import { render, staticRenderFns } from "./gameManagement.vue?vue&type=template&id=a74c69b0&scoped=true&"
import script from "./gameManagement.vue?vue&type=script&lang=js&"
export * from "./gameManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74c69b0",
  null
  
)

export default component.exports